(() => {
  if (window.FMWishlist) return;

  const STORAGE_KEY = 'fm-wishlist';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((key) => typeof key === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  let items = read();

  const write = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Private mode or full storage: the wishlist still works for this page view.
    }
  };

  const replay = (element, className, duration) => {
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
    clearTimeout(element.fmReplayTimer);
    element.fmReplayTimer = setTimeout(() => element.classList.remove(className), duration);
  };

  const sync = (scope = document) => {
    const saved = new Set(items);
    scope.querySelectorAll('[data-fm-wishlist]').forEach((button) => {
      const on = saved.has(button.dataset.fmWishlist);
      button.classList.toggle('is-saved', on);
      button.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('.fm-icon-btn--heart').forEach((icon) => {
      icon.classList.toggle('is-saved', items.length > 0);
    });
  };

  const toggle = (key, force) => {
    const had = items.includes(key);
    const saved = force === undefined ? !had : Boolean(force);
    if (saved === had) return saved;
    items = saved ? [...items, key] : items.filter((item) => item !== key);
    write();
    sync();
    document.dispatchEvent(
      new CustomEvent('fm:wishlist:change', { detail: { key, saved, items: [...items] } })
    );
    return saved;
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-fm-wishlist]') : null;
    if (!button) return;
    event.preventDefault();
    if (toggle(button.dataset.fmWishlist)) replay(button, 'is-burst', 800);
    document.querySelectorAll('.fm-icon-btn--heart').forEach((icon) => replay(icon, 'is-bump', 1000));
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    items = read();
    sync();
  });

  document.addEventListener('shopify:section:load', (event) => sync(event.target));

  window.FMWishlist = {
    get items() {
      return [...items];
    },
    has: (key) => items.includes(key),
    toggle,
    sync,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync(), { once: true });
  } else {
    sync();
  }
})();
